export default {"src":"/_next/static/media/Stone Pointer.3109f9a5.svg","height":81,"width":25};